import WhiteCard from "features/metadesk/importList/components/WhiteCard";
import React, { useEffect, useMemo, useState } from "react";
import { Box } from "@mui/material";
import { apiUrl } from "features/configure";
import { useOutletContext } from "react-router";
import axios from "axios";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import Grid from "@metacrm/metacrm-material-ui/dist/Grid";
import BehaviorBarChart from "./behavior/BehaviorBarChart";
import { useIntl } from "react-intl";

export default function XBehavior() {
  const { formatMessage } = useIntl();
  const [option, setOption] = useState("all");
  const [loading, setLoading] = useState(false);
  const dispatchSnackbar = useDispatchSnackbar();
  const [entityName] = useOutletContext();
  const [data, setData] = useState({
    handleCount: 0,
    commonFollowing: [],
    topTenBrand: [],
    topTenKOL: [],
  });
  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const { data } = await axios.get(
          apiUrl + `/api/customerReport/${entityName}/xAnalytics`
        );
        setData(data);
      } catch (err) {
        dispatchSnackbar({ err });
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [option]);

  const commonFollowingData = useMemo(() => {
    return data.commonFollowing.slice(0, 10);
  }, [data.commonFollowing]);

  const topTenBrandData = useMemo(() => {
    return data.topTenBrand.slice(0, 10);
  }, [data.topTenBrand]);

  const topTenKOLData = useMemo(() => {
    return data.topTenKOL.slice(0, 10);
  }, [data.topTenKOL]);

  function onClickLabel(label, value) {
    window.open(`https://x.com/${label}`, "_blank");
  }

  return (
    <div>
      <Box className="title">
        {formatMessage({ id: "xAnalytics.report.title" })}
      </Box>
      <Box className="description" mb="24px">
        {formatMessage({ id: "xAnalytics.report.description" })}
      </Box>
      <Grid container spacing={2} mb="20px">
        <Grid item sm={3}>
          <WhiteCard
            label={formatMessage({ id: "global.field.handleCount" })}
            value={parseInt(data.handleCount).toLocaleString()}
            width={"100%"}
          />
        </Grid>
      </Grid>
      <BehaviorBarChart
        loading={loading}
        type={"number"}
        data={commonFollowingData}
        chartName={formatMessage({
          id: "xAnalytics.chart.title.top10FollowingHandles",
        })}
        onClick={onClickLabel}
      />
      <Box sx={{ height: "10px" }} />
      <BehaviorBarChart
        loading={loading}
        type={"number"}
        data={topTenBrandData}
        chartName={formatMessage({ id: "xAnalytics.chart.title.top10Brand" })}
        onClick={onClickLabel}
      />
      <Box sx={{ height: "10px" }} />
      <BehaviorBarChart
        loading={loading}
        type={"number"}
        data={topTenKOLData}
        chartName={formatMessage({ id: "xAnalytics.chart.title.top10KOL" })}
        onClick={onClickLabel}
      />
    </div>
  );
}
